import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { computed, reactive, onUnmounted, watch } from "vue";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import useVuelidate from "@vuelidate/core";
  import {
    email,
    helpers,
    numeric,
    minLength,
    required,
    requiredIf,
  } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import CreateInitialHoldForm from "@/components/initial-hold/CreateInitialHoldForm.vue";
  import { validPhoneNumber } from "@/helpers/validation";
  import { HolderType } from "@/enums/InitialHoldHolderType";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateInitialHoldForm',
  props: {
    showFormErrors: {
      type: Boolean,
      default: false,
    },
    isBuilderOrChannelPartnerAdded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const showErrors = computed(() => {
    return props.showFormErrors;
  });
  const formFields = reactive({
    firstName: "",
    lastName: "",
    email: "",
    postcode: "",
    state: "",
    phone: "",
    holderType: null,
    builderOrPartnerFirstName: "",
    builderOrPartnerLastName: "",
    builderOrPartnerEmail: "",
    builderOrPartnerPhone: "",
    builderOrPartnerCompany: "",
  });

  const emits = __emit;

  const form = reactive(Object.assign({}, formFields));

  const rules = computed(() => {
    const VALID_PHONE_NUMBER_ERROR_TEXT = "Value must be valid phone number";
    const IS_REQUIRED_ERROR_TEXT = "Value is required";

    return {
      firstName: { required, $autoDirty: true },
      email: { required, email },
      lastName: { required, $autoDirty: true },
      holderType: {
        required,
      },
      phone: {
        validPhoneNumber: helpers.withMessage(
          VALID_PHONE_NUMBER_ERROR_TEXT,
          validPhoneNumber
        ),
      },
      postcode: { required, numeric, minLength: minLength(4) },

      builderOrPartnerFirstName: {
        required: helpers.withMessage(
          IS_REQUIRED_ERROR_TEXT,
          isBuilderOrPartnerFieldsRequired.value
        ),
        $autoDirty: true,
      },
      builderOrPartnerLastName: {
        required: helpers.withMessage(
          IS_REQUIRED_ERROR_TEXT,
          isBuilderOrPartnerFieldsRequired.value
        ),
        $autoDirty: true,
      },
      builderOrPartnerEmail: {
        required: helpers.withMessage(
          IS_REQUIRED_ERROR_TEXT,
          isBuilderOrPartnerFieldsRequired.value
        ),
        email,
      },
      builderOrPartnerPhone: {
        validPhoneNumber: helpers.withMessage(
          VALID_PHONE_NUMBER_ERROR_TEXT,
          validateBuilderOrPartnerPhone
        ),
      },
      builderOrPartnerCompany: {
        required: helpers.withMessage(
          IS_REQUIRED_ERROR_TEXT,
          isBuilderOrPartnerFieldsRequired.value
        ),
      },
    };
  });

  const isBuilderOrPartnerFieldsRequired = computed(() =>
    requiredIf(() => props.isBuilderOrChannelPartnerAdded)
  );
  const validateBuilderOrPartnerPhone = (value: string) => {
    if (!props.isBuilderOrChannelPartnerAdded) {
      return true;
    }

    return validPhoneNumber(value);
  };
  const v$ = useVuelidate(rules, form);

  watch(
    () => props.isBuilderOrChannelPartnerAdded,
    () => {
      if (!props.isBuilderOrChannelPartnerAdded) {
        return;
      }

      resetVuelidateErrors(v$);
    },
    { deep: true, immediate: true }
  );
  watch(
    () => props.showFormErrors,
    () => {
      if (props.showFormErrors) {
        v$.value.$touch();
        v$.value.$validate();
      }
    },
    { deep: true }
  );
  watch(
    form,
    async () => {
      const isValid = await v$.value.$validate();

      emits("change", {
        ...form,
        isValid,
      });
    },
    { deep: true, immediate: true }
  );
  onUnmounted(() => {
    Object.assign(form, formFields);
    resetVuelidateErrors(v$);
  });

const __returned__ = { props, showErrors, formFields, emits, form, rules, isBuilderOrPartnerFieldsRequired, validateBuilderOrPartnerPhone, v$, Modal, DropDown, computed, reactive, onUnmounted, watch, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get numeric() { return numeric }, get minLength() { return minLength }, get required() { return required }, get requiredIf() { return requiredIf }, get resetVuelidateErrors() { return resetVuelidateErrors }, CreateInitialHoldForm, get validPhoneNumber() { return validPhoneNumber }, get HolderType() { return HolderType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})